//componente per spostare giu o su nella toc ogni layer di un servizio
import React from 'react';
import { connect } from 'react-redux';
import {selectDataList} from '../../../../redux'
import MenuItem from '@material-ui/core/MenuItem';
import { Trans } from 'react-i18next';
import { useTranslation } from 'react-i18next';

function UpDownLayer(props) {
  const { t } = useTranslation();
  
  const dataList = props.dataList.data
  

  const indexService = props.dataList.data.children.findIndex(element=>{return element.children.find(x=>{return x.id===props.nodes.id && x.name===props.nodes.name})})
  
  
  const indexLayer = props.dataList.data.children[indexService].children.findIndex(x=>{return x.id===props.nodes.id && x.name===props.nodes.name})
  
  
  function array_move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; 
};

   const downLayer =() =>{
    if (indexLayer < (props.dataList.data.children[indexService].children.length - 1) && props.dataList.data.children[indexService].children.length > 1 ){
        array_move(dataList.children[indexService].children, indexLayer,indexLayer+1)
        props.changeDataList(dataList)
    }
         
      }

      const upLayer = () =>{
              if (indexLayer > 0 && props.dataList.data.children[indexService].children.length > 1 ){
                array_move(dataList.children[indexService].children, indexLayer,indexLayer-1)
                props.changeDataList(dataList)
  
      }
      
       
      } 

    return  <div>
                <MenuItem  onClick={upLayer} >{t("Sposta su")}</MenuItem>  
                <MenuItem  onClick={downLayer} >{t("Sposta giu")}</MenuItem>
                
            </div>
}
const mapStateToProps = state => {
    return {
        dataList: state.dataList
    }
  }
  const mapDispatchToProps = dispatch => {
    return {
      changeDataList: (dataList) => dispatch(selectDataList(dataList))
    }
  }
export default connect(mapStateToProps,mapDispatchToProps)(UpDownLayer)